;(function cartCtaObserver() {
    function cartCtaObserver() {
        /**
         * local template service
         * @private
         */
        var _this = this

        /**
         * config
         */
        this.config = window.Creaton.Cart.Configuration

        /**
         * cart data service
         * @property cartDataService
         * @type {function}
         */
        this.cartDataService = new window.Creaton.CartDataService()

        this.init = function () {
            _this.config = window.Creaton.Cart.Configuration
            _this.handleButtonPresentation()
        }

        /**
         * handleButtonPresentation
         * @return {undefined}
         */
        this.handleButtonPresentation = function () {
            _this.config = window.Creaton.Cart.Configuration
            $.each(_this.config.$cartModalCta, function (index, value) {
                var that = this
                var colors = $(this).data('colors')
                $(that).removeClass('btn-with-check')
                $.each(colors, function (index, color) {
                    if (_this.isProductVariantInCart(color)) {
                        $(that).addClass('btn-with-check')
                        return false
                    }
                })
            })
        }

        /**
         * handleHeaderIconPresentation
         * @return {undefined}
         */
        this.handleHeaderIconPresentation = function () {
            if ($.isEmptyObject(_this.config.cartItems) || _this.config.cartItems === null) {
                _this.config.$cartHeaderIconCounter.empty()
                _this.config.$cartHeaderIcon.removeClass('btn-with-counter')
            } else {
                _this.config.$cartHeaderIconCounter.empty()
                _this.config.$cartHeaderIcon.addClass('btn-with-counter')
                _this.config.$cartHeaderIconCounter.append(_this.cartDataService.getTotalAmountOfSamples())
            }
        }
        /**
         * check if given color in local cart
         * @param color
         * @return {boolean}
         */
        this.isProductVariantInCart = function (color) {
            return _this.config.cartItems.hasOwnProperty(color['orderCode'])
        }

        /**
         * Handle the button appearance when the local cart is updated
         */
        $(document).on(_this.config.cartEventListener, function (event, properties) {
            _this.handleButtonPresentation()
            _this.handleHeaderIconPresentation()
        })

        /**
         * Handle the button appearance onload
         */
        _this.handleButtonPresentation()

        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }
    window.Creaton.cartCtaObserver = cartCtaObserver
})()
